import { Layout, Panel, Textbox, DataSource } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlNetwork extends Layout {
    panelNetworkContent: Panel;
    sourceMCControl: DataSource;
    textboxUrl: Textbox;
    textboxQueueName: Textbox;
    textboxMcLeodServer: Textbox;
    textboxIpHost: Textbox;
    textboxWebPage: Textbox;
    textboxServerPort: Textbox;
    textboxClientPort: Textbox;
}
